// extracted by mini-css-extract-plugin
export default {"wrapper":"jS-z","availablePromoMessagesLabel":"kS-z","promoMessageList":"lS-z","promoMessage":"mS-z","appliedPromoMessage":"nS-z","promoMessageAmount":"oS-z"};